import { h, Component } from 'preact';
import Store from 'store/store';
import { post, removeLocalCookiesToken } from 'utils/api';
import { joinClasses } from 'utils/utils';
import { MODAL_TYPES, alert, confirm } from 'utils/modal';
import { trackGAEvent } from 'utils/track';

import IconBack from 'components/icons/backArrow';

import s from 'components/header/header.scss';

export default class Header extends Component {
	constructor(props) {
		super(props);
		this.back = this.back.bind(this);
		this.signOut = this.signOut.bind(this);
	}

	back() {
		this.props.backAction?.();
	}

	async signOut() {
		const confirmed = await confirm(
			'Signing out will synchronize your scans',
			{ title: 'ARE YOU SURE?', type: MODAL_TYPES.YES_NO, primaryButton: 'no' }
		);
		if (!confirmed) {
			return;
		}
		this.setState({ signOutPending: true });
		try {
			await this.props.uploadChanges();
		} catch (err) {
			console.error(err);
			this.setState({ signOutPending: false });
			await alert('There was an error synchronizing your scans. Please make sure you are connected to the internet and try again.');
			return;
		}
		try {
			trackGAEvent('signout-cta', 'search', '');
			await post('/auth/logout');
			removeLocalCookiesToken();
			Store.emit('REQUEST_LOGIN');
			this.setState({ signOutPending: false });
		} catch (err) {
			this.setState({ signOutPending: false });
			await alert('Could not sign you out, but your scans were saved!');
		}
	}

	render(props, state) {
		const { showSignOut, hideTitle, backAction } = props;
		const { signOutPending } = state;

		return (
			<header
				class={joinClasses(
					s.root,
					showSignOut && s.showSignOut,
					signOutPending && s.signOutPending,
					hideTitle && s.hideTitle,
					backAction && s.showBack,
				)}
			>
				<div class={s.left}>
					<button class={s.back} onClick={this.back}>
						<IconBack />
					</button>
				</div>
				{!hideTitle && <div class={joinClasses(s.logo, !showSignOut && s.loginPage)} />}
				{/* <h1 class={s.title}>prime premiere</h1> */}
				<div class={s.right}>
					<button class={s.signOut} onClick={this.signOut}>Sign Out</button>
				</div>
			</header>
		);
	}
}